export const combineImageUrl = (imageUrl: string) =>
  imageUrl ? `${process.env.REACT_APP_BASE_IMAGE_URL}${imageUrl}` : ''
export const combineFileUrl = (fileUrl: string) => (fileUrl ? `${process.env.REACT_APP_BASE_IMAGE_URL}${fileUrl}` : '')
